module.exports = __webpack_public_path__ + "static/media/8b8cbec4-6f47-475c-8267-02d3733d672c_1.6fa2b621a59a254bf054b737c8b7db4c.03b73925.jpeg";